const initialState = { processorConnections : [], filteredData : [] };

export const PROCESSORCONNECTIONREDUCER = (state = initialState, action) => {

    switch (action.type) {
        case 'GET_PROCESSORCONNECTIONS':
            return {
                ...state,
                processorConnections: action.data,
            }
        case 'FILTER_CONNECTIONS':
            return {
                ...state,
                filteredData: action.data
            }
        default:
            return state;
    }
}